import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fileHandlerUrl } from '../../../utils/consts/server';
import { returnFlightDate } from '../../../utils/utility';
import './tourCard.scss';
import { Button, Tooltip, ImagePreview, Modal } from '../../../component';
import {
  PhotoGalleryIcon,
  LocationIcon,
  CalendarIcon,
  TourNameIcon,
  TypeTransportationIcon,
  HotelIcon,
  DurationIcon,
  LeftLongIcon,
  RightLongIcon,
  UsersIcon,
} from '../../../content/svg-component';
const TourCard = ({
  buttonLabelId = '',
  intl = {},
  language = { name: 'en', direction: 'ltr' },
  data = {},
  key,
  onSelect = () => {},
}) => {
  const [isModalShown, setIsModalShown] = useState(false);
  const svgComponent = {
    date: CalendarIcon,
    location: LocationIcon,
    tourName: TourNameIcon,
    transportation: TypeTransportationIcon,
    residency: HotelIcon,
    duration: DurationIcon,
    users: UsersIcon,
  };

  const { images, tourInfo, facilities, duration, bookingDeadLine } = data;
  return (
    <>
      <Modal
        title={
          <h5 className="modal-title text-center w-100 text-uppercase text-primary">
            {intl.formatMessage({ id: 'tour.tourimages' })}
          </h5>
        }
        isOpen={isModalShown}
        onClose={() => setIsModalShown(false)}
      >
        <ImagePreview images={images} />
      </Modal>
      <div className="w-100 d-flex flex-md-row flex-column justify-content-start bg-white default-border-radius-small border mt-4 tour-card-info">
        <div
          className="w-100 col-md-3 position-relative cursor-pointer p-2"
          onClick={() => setIsModalShown(true)}
        >
          <img
            className="w-100 default-border-radius-small tour-card-image"
            src={`${fileHandlerUrl}/file/show/${images[0]}`}
            alt="Tour"
          />
          {images?.length > 1 && (
            <span className="position-absolute position-absolute bg-third-light px-1 rounded photo-gallery-icon">
              <PhotoGalleryIcon />
            </span>
          )}
        </div>
        <div className="w-100 col-md-9 d-flex flex-column flex-md-row py-3 font-small">
          <div className="w-100 col-md-8 h-100 d-flex flex-column justify-content-between p-2 gap-5px">
            <span className="w-100 d-flex text-start text-primary font-normal text-truncate p-0">
              {tourInfo?.name?.[language?.name]}
            </span>
            <span className="w-100 d-flex text-start text-dark text-truncate p-0">
              {returnFlightDate(tourInfo?.startDate, language?.name, true)}
            </span>
            <div className="w-100 d-flex align-items-center text-dark gap-5px">
              <span className="d-flex text-start text-truncate p-0">
                {tourInfo?.origin?.name?.[language?.name]}
              </span>
              {language?.direction === 'rtl' ? (
                <LeftLongIcon color="#3d4a8f" variant="svg-normal" />
              ) : (
                <RightLongIcon color="#3d4a8f" variant="svg-normal" />
              )}
              <span className="d-flex text-start text-truncate p-0">
                {tourInfo?.destination?.name?.[language?.name]}
              </span>
            </div>
            <ul className="w-100 d-flex flex-wrap align-items-center list-unstyled p-0 m-0 gap-5px">
              {facilities?.slice(0, 3)?.map(({ iconName, name, _id }) => (
                <li
                  key={_id}
                  className="col-3 d-flex align-items-center text-dark p-0"
                >
                  <img
                    alt="icon"
                    src={`${fileHandlerUrl}/file/show/${iconName}`}
                    width={12}
                    height={12}
                    className="d-flex align-items-cenetr justify-content-center rounded"
                  />
                  <span className="text-center text-nowrap text-truncate mx-2">
                    {name?.[language.name] ? name?.[language.name] : name?.en}
                  </span>
                </li>
              ))}
              {facilities?.length > 3 && (
                <li className="col-1 text-dark p-0">...</li>
              )}
            </ul>
          </div>
          <div className="w-100 col-md-4 h-100 d-flex flex-column align-items-center justify-content-between p-2 gap-5px">
            <div className="w-100 d-flex flex-row flex-md-column align-items-center justify-content-center px-0 gap-5px">
              <span className="w-50 w-sm-100 d-flex align-items-center justify-content-center text-nowrap text-dark p-0">
                {intl.formatMessage({ id: 'tour.duration' })}
              </span>
              <span className="w-100 d-flex align-items-center justify-content-center text-primary text-truncate p-0">
                {duration ? duration : '---'}
              </span>
            </div>
            <div className="w-100 d-flex flex-row flex-md-column align-items-center justify-content-center px-0 gap-5px">
              <span className="w-50 w-sm-100 d-flex align-items-center justify-content-center text-nowrap text-dark p-0">
                {intl.formatMessage({ id: 'tour.capacity' })}
              </span>
              <span className="w-100 d-flex align-items-center justify-content-center text-primary text-truncate p-0">
                {tourInfo?.capacity ? tourInfo?.capacity : '---'}
              </span>
            </div>
            <div className="w-100 d-flex flex-row flex-md-column align-items-center justify-content-center px-0 gap-5px">
              <span className="w-50 w-sm-100 d-flex align-items-center justify-content-center text-nowrap text-dark p-0">
                {intl.formatMessage({ id: 'tour.bookingDeadline' })}
              </span>
              <span className="w-100 d-flex align-items-center justify-content-center text-primary text-truncate p-0">
                {returnFlightDate(bookingDeadLine, language?.name, true)}
              </span>
            </div>
            <Button
              name={`select-tour-${key}`}
              id={`select-tour-${key}`}
              className="btn-secondary"
              width="w-100 px-0 py-4"
              type="reset"
              label={intl.formatMessage({
                id: buttonLabelId,
              })}
              onClick={() => onSelect(data)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

TourCard.propTypes = {
  buttonLabelId: PropTypes.string,
  intl: PropTypes?.object,
  language: PropTypes?.object,
  data: PropTypes?.object,
  onSelect: PropTypes?.func,
};

export default TourCard;
